import { Spin, Timeline } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { StatusBadge } from '@/Ship/Components/UI/StatusBadge/StatusBadge'
import { cx } from '@/Ship/Helpers/cssClass'

import { formatDateTime } from '../../Helpers/formatDate'
import { buildHistoryEntries } from '../../Helpers/historyEntries'
import { RequestHistoryTabStore } from '../../Stores/RequestHistoryTabStore'

import styles from './RequestHistoryTab.module.css'

/**
 * Вкладка «Історія» картки заявки: усі події з бекенда (створення, статуси заявки й
 * виконавців, делегування, скасування) таймлайном, новіші зверху; бейдж події, дата,
 * перехід статусу бейджами, диспетчер/причина і хто змінив.
 */
export const RequestHistoryTab = observer(({ formContext }: any) => {
    const [store] = useState(() => new RequestHistoryTabStore())
    // uuid може з'явитись після завантаження картки — читаємо з formContext напряму
    const uuid: string | undefined = formContext?.values?.uuid

    useEffect(() => {
        store.load(uuid)
    }, [store, uuid])

    if (store.loading) return <Spin style={{ display: 'block', margin: '20px auto' }} />

    const entries = buildHistoryEntries(store.history, formContext?.values)
    if (entries.length === 0) return <span className={cx(styles, 'empty')}>Історія порожня</span>

    return (
        <Timeline
            items={entries.map((entry) => ({
                key: entry.key,
                color: entry.event.color,
                children: (
                    <div className={cx(styles, 'item')}>
                        <div className={cx(styles, 'head')}>
                            <StatusBadge option={entry.event} />
                            {entry.occurredAt && (
                                <span className={cx(styles, 'meta')}>{formatDateTime(entry.occurredAt)}</span>
                            )}
                            {entry.need && <span className={cx(styles, 'meta')}>{entry.need}</span>}
                        </div>
                        {entry.transition && (
                            <div className={cx(styles, 'transition')}>
                                <StatusBadge
                                    option={{
                                        value: entry.transition.from,
                                        label: entry.transition.from,
                                        color: entry.transition.fromColor,
                                    }}
                                />
                                <span className={cx(styles, 'arrow')} aria-label="змінено на">
                                    →
                                </span>
                                <StatusBadge
                                    option={{
                                        value: entry.transition.to,
                                        label: entry.transition.to,
                                        color: entry.transition.toColor,
                                    }}
                                />
                            </div>
                        )}
                        {entry.lines.map((line) => (
                            <div key={line} className={cx(styles, 'line')}>
                                {line}
                            </div>
                        ))}
                        {entry.changedBy && <div className={cx(styles, 'by')}>Змінив(ла): {entry.changedBy}</div>}
                    </div>
                ),
            }))}
        />
    )
})
